export default function Process() {
  const steps = [
    {
      number: "1",
      title: "사전점검",
      description: "현장 방문 및 현황 파악",
      icon: "ri-search-eye-line",
      details: ["현장 실사", "위험요인 파악", "개선사항 도출"]
    },
    {
      number: "2",
      title: "증빙",
      description: "평가·조사 및 문서화",
      icon: "ri-file-list-3-line",
      details: ["전문 평가 수행", "상세 보고서 작성", "법적 요건 충족"]
    },
    {
      number: "3",
      title: "감독 대응",
      description: "증빙자료 완비 및 대응",
      icon: "ri-shield-check-line",
      details: ["증빙자료 준비", "감독 대응 지원", "법규 준수 확인"]
    },
    {
      number: "4",
      title: "사후관리",
      description: "지속적인 모니터링",
      icon: "ri-refresh-line",
      details: ["정기 점검", "개선사항 관리", "지속적 지원"]
    }
  ];

  return (
    <section id="process" className="py-12 md:py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-slate-900 mb-4 md:mb-6">
            컨설팅 프로세스
          </h2>
          <p className="text-base md:text-xl text-slate-600 max-w-3xl mx-auto px-4">
            체계적인 4단계 프로세스로 완벽한 컨설팅을 제공합니다
          </p>
        </div>

        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-32 left-0 right-0 h-1 bg-gradient-to-r from-blue-600 via-blue-600 to-blue-600" style={{ width: 'calc(100% - 200px)', left: '100px' }}></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 relative">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-slate-200 hover:border-blue-600 group">
                  {/* Number Badge */}
                  <div className="absolute -top-5 md:-top-6 left-1/2 transform -translate-x-1/2 w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-blue-600 to-blue-700 rounded-full flex items-center justify-center text-white font-bold text-lg md:text-xl shadow-lg z-10">
                    {step.number}
                  </div>

                  {/* Icon */}
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-blue-50 rounded-2xl mx-auto mb-4 md:mb-6 mt-3 md:mt-4 group-hover:bg-blue-100 transition-colors duration-300">
                    <i className={`${step.icon} text-3xl md:text-4xl text-blue-600`}></i>
                  </div>

                  {/* Content */}
                  <h3 className="text-lg md:text-xl font-bold text-slate-900 text-center mb-2 md:mb-3">
                    {step.title}
                  </h3>
                  <p className="text-slate-600 text-xs md:text-sm text-center mb-4 md:mb-6">
                    {step.description}
                  </p>

                  {/* Details */}
                  <ul className="space-y-1.5 md:space-y-2">
                    {step.details.map((detail, idx) => (
                      <li key={idx} className="flex items-start text-xs md:text-sm text-slate-700">
                        <i className="ri-checkbox-circle-fill text-blue-600 mr-2 mt-0.5 flex-shrink-0"></i>
                        <span>{detail}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Arrow for mobile */}
                {index < steps.length - 1 && (
                  <div className="lg:hidden flex justify-center my-3 md:my-4">
                    <i className="ri-arrow-down-line text-2xl md:text-3xl text-blue-600"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 md:mt-16 text-center">
          <div className="bg-gradient-to-r from-blue-50 to-slate-50 rounded-2xl p-6 md:p-8 max-w-4xl mx-auto border border-blue-200">
            <h3 className="text-xl md:text-2xl font-bold text-slate-900 mb-3 md:mb-4">
              전문적이고 체계적인 프로세스
            </h3>
            <p className="text-slate-600 text-sm md:text-base leading-relaxed">
              각 단계마다 전문가가 직접 관리하며, 고객님의 사업장에 최적화된 솔루션을 제공합니다.<br />
              처음부터 끝까지 책임지고 함께합니다.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
